webpackJsonp([1],{

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(77);

var _core = __webpack_require__(123);

var _logo = __webpack_require__(634);

var _logo2 = _interopRequireDefault(_logo);

var _withStyles = __webpack_require__(5);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = function styles(theme) {
  return {
    container: {
      margin: '1em 1em 0em 1em',
      height: '100vh'
    },
    textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: 200
    },
    menu: {
      width: 200
    },
    paper: {
      height: '100vh'
    }
  };
};

var Legalities = function (_React$Component) {
  _inherits(Legalities, _React$Component);

  function Legalities() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Legalities);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legalities.__proto__ || Object.getPrototypeOf(Legalities)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      name: '',
      age: '',
      multiline: 'Controlled',
      currency: 'EUR'
    }, _this.handleChange = function (name) {
      return function (event) {
        _this.setState(_defineProperty({}, name, event.target.value));
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Legalities, [{
    key: 'render',
    value: function render() {
      var classes = this.props.classes;

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: classes.container },
          _react2.default.createElement(
            _core.Typography,
            { variant: 'display1', gutterBottom: true },
            'Legalities'
          ),
          _react2.default.createElement(
            _core.Typography,
            { variant: 'body1', gutterBottom: true },
            'Copyright 2019 Kyle Ventures'
          )
        )
      );
    }
  }]);

  return Legalities;
}(_react2.default.Component);

exports.default = (0, _withStyles2.default)(styles)(Legalities);

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/logo.01c47621.png";

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/Legalities.65e60893.js